import { Box } from '@mui/system';
import React from 'react';
import { StyledTypography } from './styles/styles';

export default class ROEGraphDisclaimer extends React.Component {
  render() {
    return (
      <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
        <StyledTypography
          variant="caption"
          sx={{
            fontSize: '0.875rem',
            color: 'text.secondary',
            fontStyle: 'italic',
            textAlign: 'center',
          }}
        >
          Disclaimer: All figures are estimates only and are based on assumptions which may change
          over the course of the investment term. Please contact the Fund Manager for more
          information.
        </StyledTypography>
      </Box>
    );
  }
}
